import { render, staticRenderFns } from "./StoreGroupbuyingEditDetail.vue?vue&type=template&id=4bfed439&"
import script from "./StoreGroupbuyingEditDetail.vue?vue&type=script&lang=js&"
export * from "./StoreGroupbuyingEditDetail.vue?vue&type=script&lang=js&"
import style0 from "./StoreGroupbuyingEditDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports